<!-- 表单使用容器 -->
<template>
  <div class="std-page-form" :class="`std-page-form--${type}`">
    <slot />
  </div>
</template>
<script>
  export default {
    name: 'StdPageForm',
    props: {
      // 可选 default 和 dialog
      type: {
        type: String,
        default: 'default'
      }
    }
  };
</script>
<style lang="less">
  .std-page-form {
    // 表单行
    .vh-form-item {
      .vh-form-item__content {
        .content-title {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 40px;

          a {
            font-size: 14px;
            font-weight: 400;
            color: #0a7ff5;

            &:hover {
              cursor: pointer;
              color: #0060cf;
            }
          }

          &.switch-label {
            color: #8c8c8c;
          }
        }

        .content-body {
          margin-top: 4px;
        }
        .content-body.at-right {
          margin-top: 12px;
          line-height: 1;
          align-items: center;
          justify-content: flex-end;
        }

        .radio-input {
          width: 110px;

          .vh-input__suffix {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 400px;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }

      .switch-label {
        color: #8c8c8c;
      }

      // radio垂直排列
      .vh-radio-group.is-vertical {
        .vh-radio:not(:first-child) {
          line-height: 22px;
          margin-top: 10px;
        }
        .vh-radio {
          margin-right: 0;
        }
      }
    }

    // 表单行自动高度
    .vh-form-item.auto-height {
      .vh-form-item__label,
      .vh-form-item__content {
        line-height: normal;

        .content-title {
          line-height: normal;

          .vh-switch {
            // swith组件在内容区
            padding-right: 6px;
          }
        }
      }

      // 表单行自定义标题
      .vh-form-item__label {
        display: inline-block;

        .label-title {
          vertical-align: middle;
        }
        .vh-switch {
          // swith组件在标题中
          margin-left: 12px;
        }
      }
    }

    // 表单行禁用
    .vh-form-item.is-disabled {
      .vh-form-item__label,
      .vh-form-item__content,
      .content-title,
      .switch-label {
        color: #bfbfbf;
      }
    }

    .content-body {
      display: flex;

      &__card {
        width: 183px;
        height: 86px;
        border: 1px solid #f2f2f2;
        background: #f2f2f2;
        border-radius: 4px;
        position: relative;
        line-height: 80px;
        text-align: center;
        color: #666666;
        margin-left: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          margin-right: 4px;
          font-size: 20px;
        }

        &:first-child {
          margin-left: 0;
        }

        &:hover {
          cursor: pointer;
        }
      }

      &__card.for-upload {
        border-style: dashed;

        .content-upload.vh-upload--picture-card {
          border: 0;
        }
      }

      &__card.is-active {
        border-color: #fb3a32;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          width: 20px;
          height: 20px;
          top: -1px;
          right: -1px;
          z-index: 10;
          background-size: contain;
          background-position: center;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgBzdi9jgFRGMbx552xUdEodQqJzlbaLXSuAdegVeza7J1wA/SIROcGiGobHYmg2+zOzjMivgZnxpmPfzI5zin4OTNGMvKTz7cAfCDaugnDaMhs9i2cxQS1tlGvcpjFAmVZIzmdxwC1lsuVqFHithglynBbfJnPW/bwiQCTQgHKIBYUSlIpJLpdmPZh1OtQBgWBIsbsdADuzmYDq9+HJ5BO1CXmt1aDtVjAM0gVlRgOncPt2pBsFmavt8fYCAcznbq+jxJIBeV8W35wuw0pl88x3Bl7dDDV6k0MM+Ghr9Vq9J7J8FbxdgUaDCDFIiSXg1GpANstsFxeY1xO02kCH927TxnN5vHXY18rSKeVMczTDh26u1PjsTNKqQQkk54wvkEPUZPJ/sVuh79GQxnDfJ2y03T/zTwNYjpRWkBMF0obiOlAaQWxZ1HaQewZVCAg5hcVGIj5QQUKYl5RgYOYF1QoIKaKCg3EVFChgtgjVOggdg8VCYjdQkUGYm6oSEHsEhU5iMXk+dR5RNmHhThF1D98jrnANprgQwAAAABJRU5ErkJggg==);
        }
      }

      &__card.is-disabled {
        &:hover {
          cursor: not-allowed;
        }

        &::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(255, 255, 255, 0.5);
        }

        &::after {
          content: '未开通';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 52px;
          height: 20px;
          font-size: 12px;
          color: #fff;
          background: rgba(0, 0, 0, 0.45);
          border-bottom-left-radius: 4px;
          border-top-right-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .content-upload {
      width: 213px;
      height: 120px;

      .vh-upload--picture-card {
        width: 100%;
        height: 100%;
        border: 1px dashed #d9d9d9 !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        i {
          position: relative;
          font-size: 32px;
          height: 32px;
          width: 32px;
          line-height: 32px;
        }
        .text-tips {
          font-size: 12px;
          color: #8c8c8c;
          text-align: center;
          margin-top: 6px;
          p {
            line-height: 20px;
            padding: 0;
          }
        }
      }
    }

    // 默认使用
    &--default {
      .vh-form {
        & > .vh-form-item {
          margin-bottom: 32px;
        }
      }
    }

    // 弹窗使用表单
    &--dialog {
      .vh-form {
        & > .vh-form-item {
          margin-bottom: 24px;
        }
      }

      // 文本框强制中号
      .vh-input {
        .vh-input__inner {
          height: 36px;
          line-height: 36px;
        }
      }
    }
  }
</style>
